import { Component } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackService } from '../../service/snack.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-two-factorauth',
  standalone: false,

  templateUrl: './two-factorauth.component.html',
  styleUrl: './two-factorauth.component.scss'
})
export class TwoFactorauthComponent {
  hidespinner: boolean = true;
  verifyForm: FormGroup;
  verifyId: string = ""

  constructor(
    private authService: AuthandregistryService,
    private _fb: FormBuilder,
    private snack: SnackService,
    private router: Router
  ) {
    this.verifyForm = this._fb.group({
      code: ['', Validators.required],
    });

    // Get the verifyId from the URL
    this.verifyId = window.location.pathname.split('/')[3];

    let code = window.location.search.split('code=')[1];
    if (code?.indexOf('&') > -1) code = code.split('&')[0];

    if (code) {
      this.verifyForm.patchValue({ code: code });
      this.onSubmit();
    }
  }

  async onSubmit() {
    if (this.verifyForm.invalid || typeof this.verifyForm.value.code !== 'string') return;

    this.hidespinner = false;
    await this.authService.verify2fa(this.verifyId, this.verifyForm.value.code);
    this.hidespinner = true;
  }
  async newCode() {
    let usermail = localStorage.getItem('ids_be_loginemail')
    if (!usermail) {
      this.hidespinner = true;
      this.snack.error({  "headline": "Missing data", "text": "No E-Mail for Login found. Please go to Login-Page and log in  again." } )
      return;
    }
    this.hidespinner = false;
    let vId = await this.authService.new2faCode(usermail);
    this.hidespinner = true;
    if (vId) {
      this.router.navigate(['verify', vId]);
    }

  }
}
